import type { PropsWithChildren } from 'react'
import IzzySuccessGif from '@/assets/images/izzy/success.gif'
import { cn } from '@/lib/utils'
import { IzzySpeechBubble } from '../speech-bubble'

interface IzzySuccessProps extends PropsWithChildren {
  className?: string
}

export const IzzySuccess = ({ className, children }: IzzySuccessProps) => {
  return (
    <div className={cn('select-none flex', className)}>
      <img
        src={IzzySuccessGif}
        alt="Izzy Dizendo que conseguiu fazer as equivalências de disciplinas"
      />
      <div>
        <IzzySpeechBubble className="absolute w-80 left-40 top-[-80px]">
          {children}
        </IzzySpeechBubble>
      </div>
    </div>
  )
}
